import { IPaginationParams } from '../../../types';
import { useQuery } from 'react-query';
import { ILprDeviceFilterProps } from '../../../Devices/LprService/types';
import { IWhatsAppNumbersFilterProps } from '../../types';
import {
  getAllWhatsAppNumbersByLicenseAsync,
  getAllWhatsAppNumbersByLicenseCountAsync,
} from '../../index';
import { getUserId } from '../../../DefaultService';

const USER_ID = getUserId();

export const useGetAllWhatsAppNumbersByLicense = (
  pagination?: IPaginationParams,
  filter?: IWhatsAppNumbersFilterProps,
) =>
  useQuery([`whatsAppNumbers${pagination?.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllWhatsAppNumbersByLicenseAsync(pagination, filter),
  });

export const useGetAllWhatsAppNumbersByLicenseCount = (
  pagination: IPaginationParams,
  filter: ILprDeviceFilterProps,
) =>
  useQuery(
    [`whatsAppNumbersCount${pagination.pageNumber}`, pagination, USER_ID],
    {
      keepPreviousData: true,
      staleTime: 1000 * 60,
      queryFn: () => getAllWhatsAppNumbersByLicenseCountAsync(filter),
    },
  );
